import React from 'react'
import {
  PixelButton,
  PixelFactoryContext,
  PixelFlexBox,
  PixelInput,
  PixelText,
} from 'pixel-base'

import { registerCustomerStore } from 'utils/api-routes.util'
import {
  ManualFormHelp,
  ManualFormHelpCloseButton,
} from 'app/common/styles/section'

import HelpDaraz from './HelpDaraz'
import { IPixelFactory } from '../../../../../decl'

type Props = {
  origin: string
  onSuccessAddStore: () => void
}

const DarazManual = (props: Props) => {
  const { onSuccessAddStore } = props
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [showHelp, setShowHelp] = React.useState(false)

  const [data, setData] = React.useState({
    store_id: null,
    store_type: 'daraz',
    store_name: '',
    api_key: '',
    api_secret: '',
  })
  const [error, setError] = React.useState({ error: '', field: '' })

  const handleSubmit = (e) => {
    e.preventDefault()
    handleAddStore(data)
  }

  const handleAddStore = (data) => {
    showPageLoader()
    registerCustomerStore(data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Successfully Added')
        onSuccessAddStore()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }

  return (
    <>
      <PixelFlexBox position="relative" flexDirection="column">
        <PixelText variant="light" textSize="20px">
          Enter Daraz API Details
        </PixelText>
        <form onSubmit={handleSubmit}>
          <PixelFlexBox
            justifyContent="flex-start"
            alignItems="flex-end"
            flexDirection="column"
            gap="10px"
          >
            <PixelInput
              customLabel="Store Name"
              error={
                error.field === 'store_name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              placeholder="e.g. My Daraz Store"
              value={data.store_name}
              onChange={(e) =>
                setData({
                  ...data,
                  store_name: e.currentTarget.value,
                })
              }
            />

            <PixelInput
              customLabel="User ID/ Email Address"
              error={
                error.field === 'api_key' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              placeholder="e.g. yourname@gmail.com"
              value={data.api_key}
              onChange={(e) =>
                setData({
                  ...data,
                  api_key: e.currentTarget.value,
                })
              }
            />
            <PixelInput
              customLabel="API Key"
              error={
                error.field === 'api_secret' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              value={data.api_secret}
              onChange={(e) =>
                setData({
                  ...data,
                  api_secret: e.currentTarget.value,
                })
              }
              placeholder="e.g. cs_1455520d84f605cb7df7940b30625ae25388xxxx"
            />
            <PixelFlexBox
              justifyContent="flex-end"
              alignItems="flex-end"
              gap="10px"
              width="100%"
            >
              <PixelButton
                onClick={() => setShowHelp(true)}
                variant="secondary"
              >
                Help
              </PixelButton>
              <PixelButton type="submit">Add Store</PixelButton>
            </PixelFlexBox>
          </PixelFlexBox>
        </form>
        <ManualFormHelp className={showHelp ? 'show' : ''}>
          <ManualFormHelpCloseButton onClick={() => setShowHelp(false)}>
            &times;
          </ManualFormHelpCloseButton>
          <HelpDaraz />
        </ManualFormHelp>
      </PixelFlexBox>
    </>
  )
}

export default DarazManual
